import { useState, useEffect } from 'react'
import './FuturisticLoader.css'

const MESSAGES = [
  'INICIALIZANDO NÚCLEO NEURAL...',
  'CONECTANDO AL SERVIDOR DE VOZ...',
  'AUTENTICANDO FIRMA DE VOZ...',
  'CALIBRANDO MATRIZ ANALÓGICA...',
  'ESTABLECIUENDO CONEXIÓN CIFRADA...',
  'SINCRONIZANDO FLUJOS DE AUDIO...',
  'OPTIMIZANDO LATENCIA DE RESPUESTA...',
  'LISTO PARA EL ENLACE.'
]

export default function FuturisticLoader({ loading }) {
  const [messageIndex, setMessageIndex] = useState(0)
  const [shouldRender, setShouldRender] = useState(true)

  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % MESSAGES.length)
    }, 1500)
    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    if (!loading) {
      const timer = setTimeout(() => setShouldRender(false), 800)
      return () => clearTimeout(timer)
    } else {
      setShouldRender(true)
    }
  }, [loading])

  if (!shouldRender) return null

  return (
    <div className={`loader-overlay ${!loading ? 'hidden' : ''}`}>
      <div className="grid-bg"></div>
      <div className="scan-line"></div>
      <div className="vignette"></div>

      <div className="core-container">
        <div className="core-outer"></div>
        <div className="core-inner"></div>
      </div>

      <div className="status-container">
        <span className="status-text dark-glow">KERBOT CARGANDO...</span>
        <div className="status-message">
          {MESSAGES[messageIndex]}
        </div>
      </div>

      <div className="waveform-container">
        {[...Array(15)].map((_, i) => (
          <div
            key={i}
            className="waveform-bar"
            style={{ animationDelay: `${i * 0.08}s` }}
          ></div>
        ))}
      </div>
    </div>
  )
}
